import { useEffect, useState } from 'react'
import { Outlet, Navigate, useParams, useNavigate } from 'react-router-dom'
import Footer from 'ui/src/components/Footer'
import Header from 'components/public/Header'
import Services from 'services'
import globalStore from 'store'
import { StyledBox } from './styles'
import AppTheme from '../AppTheme'
import AppLoading from '../AppLoading'

interface AppRegisterLayoutProps {
  companyInvite?: boolean
}

const AppRegisterLayout = ({ companyInvite = false }: AppRegisterLayoutProps) => {
  const user = globalStore(state => state.user)
  const [isInvalidInviteLoading, setIsInvalidInviteLoading] = useState<boolean | null>(true)
  const { v2, uuid, jwtToken } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    const checkInvite = async () => {
      if (v2 || uuid || jwtToken) {
        try {
          if (v2) {
            await Services.Invite.checkInviteV2(v2)
          } else if (uuid) {
            await Services.Invite.checkInvite(uuid)
          } else if (jwtToken) {
            await Services.Company.checkInvite(jwtToken)
          }
          setIsInvalidInviteLoading(false)
        } catch {
          // Navigate to shared error page (works for both V1 and V2)
          navigate('/company/invalid-invite')
        }
      } else {
        navigate('/')
      }
    }
    if (companyInvite) checkInvite()
  }, [companyInvite, jwtToken, navigate, uuid, v2])

  if (companyInvite && isInvalidInviteLoading)
    return (
      <AppTheme>
        <AppLoading />
      </AppTheme>
    )

  if (user) return <Navigate to="/redirect" />

  return (
    <>
      <Header />
      <StyledBox>
        <Outlet />
      </StyledBox>
      <Footer />
    </>
  )
}

export default AppRegisterLayout
